/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for instanceType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="instanceType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="copy"/&gt; &lt;enumeration value="local"/&gt; &lt;enumeration value="missing"/&gt; &lt;enumeration value="reference"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class InstanceType extends Enum{

	enumValue = null;

	/**
	 * This instance is a copy of another instance.
	 */
	static  COPY = InstanceType.newLiteral("copy");

	/**
	 * This instance is defined locally.
	 */
	static  LOCAL = InstanceType.newLiteral("local");

	/**
	 * This instance is a reference of another instance. However, the referenced instance is missing. This value is a feedback message to client. Module that has metadata objects with missing instanceType is invalid. Saving an invalid module is not allowed.  
	 */
	static  MISSING = InstanceType.newLiteral("missing");

	/**
	 * This instance is a reference of another instance.
	 */
	static  REFERENCE = InstanceType.newLiteral("reference");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < InstanceType.values().length); ++i) {
			if (InstanceType.values()[i].enumValue == v) {
				return InstanceType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("InstanceType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/InstanceType.js